import { modules, modulesMetaData } from '../../components/CrossModuleLink/modules';
import { User } from './types';
import { getPageUrl } from '../../components/CrossModuleLink/utils';
// eslint-disable-next-line
import { decodeListDataFilter } from '../list';
import { CustomObject } from '../../types';

export const getUserDetailsUrl = (
	entityId: number | null,
	organizationId: number | null,
	listData: string | null,
): string => {
	if (!entityId || !organizationId) {
		return '';
	}

	return getPageUrl({
		module: modules.USER,
		route: modulesMetaData[modules.USER].detail,
		routeParam: entityId,
		params: {
			organizationid: organizationId,
			listData: listData,
		},
	});
};

export const getListPageUrl = (search) => {
	const urlSearchParams = new URLSearchParams(search);

	return getPageUrl({
		module: modules.USER,
		route: modulesMetaData[modules.USER].list,
		params: decodeListDataFilter(urlSearchParams.get('listData')),
	});
};

export function getUserContextFromDOM(): Partial<User> {
	const root = document.getElementById('root');

	if (root !== null && typeof root.dataset.userContext !== 'undefined') {
		return JSON.parse(root.dataset.userContext) as CustomObject;
	}

	return {};
}
